import { actions } from '@adc/ui-morpheus'
import { getUsers } from '../providers/user'
import { USERS } from '../constants/tableTypes'
import {
  UPDATE_USER_IN_LIST,
  STORE_PARTY_ID,
  CLEAN_PARTY_ID,
} from '../constants/actionTypes'

export const {
  fetchTable,
  fetchTableAppend,
  fetchTableBatches,
  addFilter,
  clearFilters,
  changeSortBy,
  removeFilter,
} = actions.dataTable.initDataTable(USERS, {
  getTableValues: getUsers,
})

/**
 * No need for the usual "clearUsers" kind of action because we are not creating new users
 * in this app (which needs the clear list action to reload the view)
 */

export const updateUserInList = user => ({
  type: UPDATE_USER_IN_LIST,
  user,
})

export const storePartyId = user => ({
  type: STORE_PARTY_ID,
  user,
})

export const cleanPartyId = user => ({
  type: CLEAN_PARTY_ID,
  user,
})

export const { abortTableValues, resetTableValues } = actions.dataTable
